import React from 'react';
import logoSAWbw from './SAW-Logo_weiss_RGB.svg';
import { defineMessages, useIntl } from 'react-intl';
import { Container as SemanticContainer } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import { Grid } from 'semantic-ui-react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { NavLink } from 'react-router-dom';


const messages = defineMessages({
    FindUsOn: {
        id: 'Find us on',
        defaultMessage:
            'Find us on',
    },
});

const mainFooter = (props) => {
    const intl = useIntl();
    const items = useSelector((state) => state.navigation.items, shallowEqual);
    const filtered_items = items.filter((item) => {
        return (
            item.review_state &&
            item.title !== 'Home')

    });
    const Container =
        config.getComponent({ name: 'Container' }).component || SemanticContainer;

    return (
        <Container className="layout saw-main-footer">

            <div className="adress">
                Sächsische Akademie <br />
                der Wissenschaften zu Leipzig<br />
                Hauptsitz Leipzig<br />
                Karl-Tauchnitz-Str. 1<br />
                04107 Leipzig
            </div>
            <ul className="navigation-footer">
                {filtered_items.map((item, index) => (
                    <li key={item.url}>
                        <NavLink
                            to={item.url === '' ? '/' : item.url}
                        >
                            {item.nav_title ?? item.title}
                        </NavLink>

                    </li>
                ))}

            </ul>

        </Container>
    );
}

export default mainFooter;